module.exports = __webpack_public_path__ + "img/logo.e66b3ce7.png";